const CONFIG = {
  //开发环境配置
  development: {
    loginTitleTxt: "假日伙伴", // 登录页标题
    copyrightTxt: "假日伙伴v1.0.5", // 版本信息
    baseUrl: "https://jrhbapitest.jiarixiaodui.com/v2",
    //baseUrl:"https://jrhb_api.jiarixiaodui.com/v1",
    // baseUrl: "http://192.168.1.107/haoshi/jrhb_api/web/v1",
    version: "1.1.0",
    isWxBrowser: false, //是否开启强制微信浏览器打开
    debug: true,
    width: 900,
    height: 900,
    quality: 0.5,
  },

  //生产环境配置
  production: {
    loginTitleTxt: "假日伙伴", // 登录页标题
    copyrightTxt: "假日伙伴v1.0.5", // 版本信息
    assetsPath: "/assets/static", // 静态资源路径
    baseUrl: "https://jrhbapi.jiarixiaodui.com/v2",
    // baseUrl: "https://jrhb_api.jiarixiaodui.com/v1",
    version: "1.1.0",
    debug: true,
    isWxBrowser: true, //是否开启强制微信浏览器打开
    width: 900,
    height: 900,
    quality: 0.5,

  }

}
export default CONFIG[process.env.NODE_ENV];
